import { defineStore } from 'pinia';
import { WidgetUUID } from '@/common/utils';
import { isNil } from 'lodash-es';
import { ref } from 'vue';
import { WidgetObserver } from '@/dashboard/shared/utils/observer.utils';
import { ReferenceInfo } from '@/dashboard/features/widgetSettings/editModeWidgetSettings/components/common/referenceSettingOption/referenceSettingOption.setup';
import { WidgetProps } from '@/dashboard/features/widgets/common/types/widgets.types';

export const useWidgetObserverStore = defineStore('widgetObserverStore', () => {
  const widgetObservers = ref(new Map<WidgetUUID, WidgetObserver>());

  const subscribeWidget = (widgetProps: WidgetProps, publish: (event: string) => void) => {
    const referenceInfo: ReferenceInfo | undefined = widgetProps.chartOption?.referenceInfo;
    if (isNil(referenceInfo)) {
      return;
    }

    Object.values(referenceInfo).forEach((referenceVariables) => {
      referenceVariables?.forEach(({ value }) => {
        switch (value?.type) {
          case 'customVariable': {
            value.selected?.forEach(({ widgetId }) => {
              if (!widgetObservers.value.has(widgetId)) {
                widgetObservers.value.set(widgetId, new WidgetObserver());
              }
              const observer = widgetObservers.value.get(widgetId)!;
              if (observer.hasListener(widgetProps.widgetId)) {
                return;
              }
              observer.subscribe({
                id: widgetProps.widgetId,
                publish,
              });
            });
            break;
          }
          default:
            break;
        }
      });
    });
  };

  const unsubscribeWidget = (widgetId: WidgetUUID) => {
    widgetObservers.value.delete(widgetId);
    widgetObservers.value.forEach((observer, targetWidgetId) => {
      observer.unsubscribe(widgetId);
      // 마지막 구독자가 해제되어 빈 옵저버가 된 엔트리는 제거한다.
      // 참조 대상 위젯이 자체적으로 마운트/언마운트되지 않는 경우(비데이터 위젯,
      // dangling reference 등)에도 Map 이 누적되지 않도록 한다.
      if (!observer.hasListeners()) {
        widgetObservers.value.delete(targetWidgetId);
      }
    });
  };

  return {
    widgetObservers,
    subscribeWidget,
    unsubscribeWidget,
  };
});
